"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = _Reflect$construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Portal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);
  var _super = _createSuper(Portal);
  function Portal() {
    var _this;
    (0, _classCallCheck2.default)(this, Portal);
    _this = _super.apply(this, arguments);
    _this.mountNode = null;
    _this.renderedTimer = undefined;
    _this.getContainer = function (container) {
      var contain = typeof container === 'function' ? container() || document.body : container;
      // eslint-disable-next-line
      return _reactDom.default.findDOMNode(contain) || _this.props.container;
    };
    _this.setMountNode = function (container) {
      var _a;
      if (_this.props.disabled) {
        // eslint-disable-next-line
        _this.mountNode = ((_a = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this))) === null || _a === void 0 ? void 0 : _a.parentElement) || null;
        return;
      }
      _this.mountNode = _this.getContainer(container);
    };
    return _this;
  }
  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        container = _this$props.container,
        disabled = _this$props.disabled,
        onRendered = _this$props.onRendered;
      this.setMountNode(container);
      if (!disabled) {
        this.forceUpdate(onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var _this$props2 = this.props,
        container = _this$props2.container,
        disabled = _this$props2.disabled,
        onRendered = _this$props2.onRendered;
      if (prevProps.container !== container || prevProps.disabled !== disabled) {
        this.setMountNode(container);
        if (!disabled) {
          this.forceUpdate(function () {
            if (onRendered) {
              clearTimeout(_this2.renderedTimer);
              _this2.renderedTimer = window.setTimeout(onRendered);
            }
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
      clearTimeout(this.renderedTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        disabled = _this$props3.disabled;
      if (disabled) {
        return children;
      }
      return this.mountNode ? /*#__PURE__*/_reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);
Portal.propTypes = {
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  onRendered: _propTypes.default.func
};
Portal.defaultProps = {
  container: document.body || document.documentElement,
  disabled: false,
  onRendered: function onRendered() {},
  children: null
};
var _default = exports.default = Portal;